const getUrl = () => {
	return process.env.NODE_ENV === "development"
		? "//localhost:5000"
		: "https://hush-computing-api.eliasmuchina.co.ke";
};

const url = getUrl();

export default url;
